import { OfferRequestsTableType } from "../../models";

export type RequestProgress = "waiting" | "sent" | "offers" | "done";

// Labels use the client's wording; change them here only.
export const requestProgressInfo: Record<
  RequestProgress,
  { label: string; color: string }
> = {
  waiting: { label: "Na čekanju", color: "orange" },
  sent: { label: "Upit poslan osiguravajućem društvu", color: "blue" },
  offers: { label: "Ponude dostavljene", color: "purple" },
  done: { label: "Završeno", color: "green" },
};

// Derived from what already happened to the request, so nobody has to switch
// the status by hand.
export const getRequestProgress = (
  request: Pick<
    OfferRequestsTableType,
    "status" | "sentCount" | "responseCount"
  >
): RequestProgress => {
  if (request.status === "Završeno") {
    return "done";
  }
  if (request.responseCount > 0) {
    return "offers";
  }
  if (request.sentCount > 0) {
    return "sent";
  }
  return "waiting";
};
